import { useMemo } from 'react';
import { useSystemClassifierItems } from '../../../../configuration';

const confidentialityStatusCodesThatAllowUsingDimension = [
  'F_C',
  'F_N',
  'N_C',
  'VALUE_X',
];

export const useIsAlgorithmConfidentialityRuleSourceDimensionEditable = (
  dataObjectConfidentialityStatusId?: number
) => {
  const confidentialityStatusItems = useSystemClassifierItems(
    'CONFIDENTIALITY_STATUS'
  );

  return useMemo(() => {
    if (!dataObjectConfidentialityStatusId) {
      return false;
    }

    const item = confidentialityStatusItems.find(
      ({ id }) => id === dataObjectConfidentialityStatusId
    );

    return Boolean(
      item?.code &&
        confidentialityStatusCodesThatAllowUsingDimension.includes(item.code)
    );
  }, [confidentialityStatusItems]);
};
